"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = require("react-dom");
const react_1 = require("react");
const PortalBody_1 = require("./PortalBody");
const Spinner_1 = require("./Spinner");
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const Portal = ({ children, id, hashId, modalSet, initialization, pending, isOpen, close, allowClickOutside, duration, modalStyle, spinner, spinnerColor, draggable, }) => {
    const [isCreatedPortal, setCreatedPortal] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!isOpen) {
                yield (0, utils_1.defer)(duration);
                const portal = (0, utils_1.$)(`.${constants_1.PREFIX.PORTAL}${hashId}`);
                const style = (0, utils_1.$)(`[data-modal-style="${constants_1.PREFIX.PORTAL}${hashId}`);
                portal && document.body.removeChild(portal);
                style && document.head.removeChild(style);
                return setCreatedPortal(false);
            }
            const portal = document.createElement('div');
            portal.classList.add(`${constants_1.PREFIX.PORTAL}${hashId}`);
            document.body.appendChild(portal);
            const style = document.createElement('style');
            style.setAttribute('data-modal-style', `${constants_1.PREFIX.PORTAL}${hashId}`);
            style.textContent = modalStyle;
            document.head.appendChild(style);
            setCreatedPortal(true);
        }))();
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        if (!initialization || isOpen)
            return;
        modalSet.delete(id);
    }, [isOpen]);
    if (!isCreatedPortal || !initialization)
        return null;
    if (pending)
        return (0, jsx_runtime_1.jsx)(Spinner_1.default, { spinner: spinner, spinnerColor: spinnerColor });
    return ReactDOM.createPortal((0, jsx_runtime_1.jsx)(PortalBody_1.default, Object.assign({ isOpen: isOpen, close: close, allowClickOutside: allowClickOutside, draggable: draggable }, { children: children })), (0, utils_1.$)(`.${constants_1.PREFIX.PORTAL}${hashId}`));
};
exports.default = Portal;
